import React from "react";
import BaseComponent from "core/gd-components/base-component/base-component";

import {AtomicBlockUtils, EditorState} from "draft-js";

import Modal from "../components/modal";
import FormManager from "../../../gd-form/common/form-manager";
import Input from "../../../gd-form/form-element/input/input";
import FormError from "../../../gd-form/common/form-error/form-error";
import Form from "../../../gd-form/form/form-modal/form-modal";

import { addImage } from '../plugins/image/image-plugin';
import ImageSourceError from "./image-source-error";

export default class ImageSource extends BaseComponent {
    constructor(props) {
        super(props);
        this._bind('onSubmit', 'onRequestClose', 'onAfterOpen');

        const { entity } = props;

        let initFormData = {src: ''};

        if (entity) {
            const data = entity.getData();
            initFormData.src = data.src ? data.src : '';
        }

        const formStructure = {
            fields: {
                src: {
                    type: 'input',
                    isRequired: true,
                    label: 'Image source',
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure, initFormData);
    }

    componentDidMount() {
        gd.bus.triggerEvent('rich-editor:image-source-open', true);
    }

    componentWillUnmount() {
        gd.bus.triggerEvent('rich-editor:image-source-open', false);
    }

    onSubmit(result) {
        const { editorState, entity, entityKey, entityType, onComplete } = this.props;
        const { src } = result;
        const content = editorState.getCurrentContent();
        let nextState;

        gd.utils.getImageDimensions(src, (width, height)=>{
            const aspectRatio = height/width;

            if (entity && entityKey) {
                const nextContent = content.mergeEntityData(entityKey, { src, aspectRatio });
                nextState = EditorState.push(editorState, nextContent, "apply-entity");
            } else {
                nextState = addImage(editorState, src, { alt: "", aspectRatio });
                // const contentWithEntity = content.createEntity( entityType.type, "MUTABLE", { alt: "", src } );
                // nextState = AtomicBlockUtils.insertAtomicBlock( editorState, contentWithEntity.getLastCreatedEntityKey(), " " );
            }

            onComplete(nextState);
        }, ()=>{
            this.imageSourceError.show();
            this.form.reset();
        });
    }

    onRequestClose(e) {
        const { onClose } = this.props;
        e.preventDefault();

        onClose();
    }

    onAfterOpen() {if (this.urlInput) this.urlInput.focus()}

    onKeyDown = (e) => {
        this.imageSourceError.hide();
        if ((e.ctrlKey || e.metaKey) && e.keyCode === 13) this.form.onSubmitClick();
    }

    render() {
        const { entity } = this.props;
        const title = entity ? "Edit image" : "Add image";

        return (
            <Modal onRequestClose={this.onRequestClose}
                   onAfterOpen={this.onAfterOpen}
                   isOpen={true}
                   contentLabel="Image chooser" >
                <div className="header">
                    <div className="title">{title}</div>
                    <div className="i5-delete" onClick={this.onRequestClose}> </div>
                </div>
                <Form form={this.form} className="gd-rich-editor-image-source-form">
                    <div className="row cf">
                        <div className="label">Image src</div>
                        <div className="element">
                            <Input ref={r=>this.urlInput = r} size="big" form={this.form} name="src" placeholder="" onKeyDown={this.onKeyDown}/>
                        </div>
                        <div className="cf"/>

                        <ImageSourceError ref={r=>this.imageSourceError = r}/>
                        <FormError className="error-message" form={this.form} name="src" />
                    </div>
                </Form>
            </Modal>
        );
    }
}
